import { Col, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router";
import { Link as ScrollLink,scroller} from "react-scroll";
import frame1 from "../Assets/images/footer-logo.png"
import call from '../Assets/images/footer-call.svg'
import email from '../Assets/images/mail.svg'

function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const handleLinkClick = (e, path) => {
  if (location.pathname === path) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  } else {
    navigate(path);
  }
};

  const handleNavClick = (section) => {
    if (location.pathname !== "/") {
      // If not on homepage, redirect and pass section
      navigate("/", { state: { scrollTo: section } });
    } else {
      // If already on homepage, scroll directly
      scroller.scrollTo(section, {
        smooth: true,
        duration: 500,
        offset: -150,
      });
    }
  };
  return (
    <>
      <div className="footer ">
        <footer
          style={{
            backgroundColor: "#0c1e45",
            color: "#ffffff",
            padding: "45px 0px 23px 0px",
          }}
        >
          <div className="container">
            <Row className="d-flex  footer-main">
              <Col lg={4} md={12} sm={6} className="mb-4 d-flex flex-column gap-3">
              <div className="footer-logo">
                <img  onClick={() => {navigate("/"); handleNavClick("home") }} src={frame1} style={{height:"70px"}} alt="" />
              </div>
              <div>

                {/* <h5>All in One Bank</h5> */}
                <p className="footer-p">
                  Your one stop platform to explore Indian banking services,
                  loan solutions, and digital banking innovations.
                </p>
              </div>
              </Col>
              <Col 
             lg={2} md={4} sm={6} className="mb-4">
                <h5>Quick Links</h5>
                <ul className="list-unstyled mt-3 d-flex flex-column gap-2 ">
                  <li onClick={() => {navigate("/"); handleNavClick("home") }}>
                    {/* <Link className="footer-p" to="/"> Home </Link> */}
                    {/* <ScrollLink  to="home" smooth={true} duration={500} offset={-70} className="footer-p" > */}
                      Home
                    {/* </ScrollLink> */}
                  </li>
                  <li  onClick={() => handleNavClick("type")}>
                    {/* <Link className="footer-p" to="/">Types of Banks </Link>  */}
                    {/* <ScrollLink className="footer-p" to="type" smooth={true} duration={500} offset={-70} > */}
                      Bank Type
                    {/* </ScrollLink> */}
                  </li>
                  <li onClick={() => handleNavClick("core-banking")}>
                    {/* <Link className="footer-p" to="/">Core Banking </Link> */}
                    {/* <ScrollLink to="core-banking" className="footer-p" smooth={true} duration={500} offset={-70}> */}
                      Services
                    {/* </ScrollLink> */}
                  </li>
                  <li onClick={() => handleNavClick("account-type")}>
                    {/* <Link className="footer-p" to="/">Loan Products </Link> */}
                    {/* <ScrollLink to="account-type" className="footer-p" smooth={true} duration={500} offset={-70}> */}
                      Account
                    {/* </ScrollLink> */}
                  </li>
                  <li onClick={() => handleNavClick("loan")}>
                    {/* <Link className="footer-p" to="/">Digital Banking </Link> */}
                    {/* <ScrollLink to="loan" className="footer-p" smooth={true} duration={500} offset={-70} > */}
                      Loans
                    {/* </ScrollLink> */}
                  </li>
                  <li  onClick={() => handleNavClick("investment")}>
                    {/* <ScrollLink to="investment" className="footer-p" smooth={true}  duration={500} offset={-70}> */}
                      Investment
                    {/* </ScrollLink> */}
                  </li>
                  <li onClick={() => handleNavClick("digital-banking")}>
                    {/* <ScrollLink to="digital-banking" className="footer-p"  smooth={true} duration={500} offset={-70}> */}
                      Digital Banking
                    {/* </ScrollLink> */}
                  </li>
                </ul>
              </Col>
              <Col lg={2} md={3} sm={6} className="mb-4">
                <h5>Resources</h5>
                <ul className="list-unstyled mt-3 d-flex flex-column gap-2">
                   <li>
                    <Link className="footer-p" to="/about" onClick={(e) => handleLinkClick(e, "/about")}>
                      About Us{" "}
                    </Link>
                  </li>
                   <li>
                    <Link className="footer-p" to="/blogs" onClick={(e) => handleLinkClick(e, "/blogs")}>
                      Blogs{" "}
                    </Link>
                  </li>
                   <li>
                    <Link className="footer-p" to="/contact" onClick={(e) => handleLinkClick(e, "/contact")}>
                      Contact Us{" "}
                    </Link>
                  </li>
                  <li>
                    <Link className="footer-p" to="/privacypolicy" onClick={(e) => handleLinkClick(e, "/privacypolicy")}>
                      Privacy Policy{" "}
                    </Link>
                  </li>
                  <li>
                    <Link className="footer-p" to="/termsofuse" onClick={(e) => handleLinkClick(e, "/termsofuse")}>
                      Terms of Use{" "}
                    </Link>
                  </li>
                </ul>
              </Col>

              <Col lg={3} md={4} sm={6} className="mb-4 d-flex flex-column gap-3">
                <h5>Contact Us</h5>
                {/* <p className="footer-p mt-3">Email: support@banksstatements.com</p>
                <p className="footer-p">Phone: +91-12345-67890</p> */}
                 <div className="d-flex gap-3 gap-sm-4 contact-div">
                    <img src={call} alt="" />
                    <p className="p mb-0" style={{color:"#f3ebeb91"}}>+91 92744 48139</p>
                  </div>
                  <div className="d-flex gap-3 gap-sm-4 contact-div">
                    <img src={email} alt="" />
                    <p className="text-start p mb-0 ms-1" style={{color:"#f3ebeb91"}}>support@banksstatements.com</p>
                  </div>
                <div className="d-flex gap-3 mt-2">
                  {/* <a href="#" className="footer-icon"><FaFacebookF /></a>
              <a href="#" className="footer-icon"><FaTwitter /></a>
              <a href="#" className="footer-icon"><FaLinkedinIn /></a>
              <a href="#" className="footer-icon"><FaInstagram /></a> */}
                </div>
              </Col>
            </Row>
          </div>
              <hr style={{ borderColor: "#f3ebeb91" }} />

            <div className="text-center">
              <p className="mb-0 footer-p">
              banksstatements © 2026. All Rights Reserved.
              </p>
            </div>
        </footer>
      </div>
    </>
  );
}

export default Footer;
